<template>
  <div id="support-chat-container"></div>
</template>

<script>
import { getSmartsuppKey } from '@/constants/vendorKeys'

export default {
  methods: {
    loadScriptAsync: function (id) {
      return new Promise((resolve, reject) => {
        if (!document.getElementById(id)) {
          var tag = document.createElement('script')
          tag.text = `var _smartsupp = _smartsupp || {}; _smartsupp.key = '${getSmartsuppKey}';          window.smartsupp||(function(d) {            var s,c,o=smartsupp=function(){ o._.push(arguments)};o._=[];            s=d.getElementsByTagName('script')[0];c=d.createElement('script');            c.type='text/javascript';c.charset='utf-8';c.async=true;            c.src='https://www.smartsuppchat.com/loader.js?';s.parentNode.insertBefore(c,s);          })(document);`
          /* tag.src = uri */
          tag.type = 'text/javascript'
          /* tag.async = true
          tag.defer = true */
          tag.setAttribute('id', id)
          tag.onload = () => {
            resolve()
          }
          document.head.appendChild(tag)
        } else {
          resolve()
        }
      })
    }
  },
  mounted () {
    // const _this = this
    let vh = window.innerHeight * 0.01
    document.documentElement.style.setProperty('--vh', `${vh}px`)
    this.loadScriptAsync('smartsupp-script-loader').then(() => {
      this.loading = false
      let chatBtn = null
      setTimeout(() => {
        chatBtn = document.getElementById('chat-application')
        if (chatBtn) {
          chatBtn.click()
        }
      }, 2000)
    })
  },
  created () {
    /* window.hsConversationsSettings = {
      loadImmediately: true,
      inlineEmbedSelector: '#support-chat-container',
      enableWidgetCookieBanner: false,
      disableAttachment: false
    } */
  }
}
</script>

<style lang="less">
  #hubspot-conversations-inline-iframe {
    height: calc(var(--vh, 1vh) * 100) !important;
    height: 100vh;
    width: 100%;
    border: 0px;
  }
</style>


// WEBPACK FOOTER //
// src/components/public/HubspotChat.vue